import {
  Component,
  ComponentFactoryResolver,
  Output,
  OnInit,
  EventEmitter,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { DialogComponent } from "../dialog/dialog.component";
import { DataService } from "./../../data.service";
import { SectionDialogComponent } from "../section-dialog/section-dialog.component";

interface DroppedData {
  id: string;
  labelname: string;
  fieldname: string;
  fieldtype: string;
  attributes: any;
  visibility: boolean;
  standard: boolean;
  readonly: boolean;
  createddate: string;
  defaultvalue: any;
  primary: boolean;
  sequence: string;
  required: boolean;
  groupfieldsattributes: any;
}
type Button = {
  fieldname: string;
  text: string;
};

@Component({
  selector: "app-section",
  templateUrl: "./section.component.html",
  styleUrls: ["./section.component.scss"],
})
export class SectionComponent implements OnInit {
  // appConfig: any;

  sectionName: string = "Account Number";

  constructor(
    public dialog: MatDialog,
    private componentFactoryResolver: ComponentFactoryResolver,
    private dataService: DataService
  ) {}

  ngOnInit() {
    console.log("Draggable component initialized.");
  }

  droppedDataFieldList: DroppedData[] = [];
  @Output() droppedDataEvent: EventEmitter<any> = new EventEmitter<any>();

  hiddenIndex: number = -1;

  delete(index: number) {
    console.log("Type Deleted", index);
    this.droppedDataFieldList.splice(index, 1);
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onSectionDrop(event: DragEvent) {
    event.preventDefault();
    const data = event.dataTransfer.getData("application/json");
    if (data.length > 0) {
      const parsedData = JSON.parse(data);
      this.droppedDataFieldList.push(parsedData);
      this.droppedDataEvent.emit(parsedData);
      console.log("Dropped data:", this.droppedDataFieldList);
      console.log("Parsed data:", parsedData);
    } else {
      const blank_data: DroppedData = {
        fieldname: "blank_space",
        fieldtype: "text",
        id: "10wP000000ZzpzH",
        labelname: "Blank Space",
        attributes: {},
        visibility: true,
        standard: true,
        readonly: false,
        createddate: "",
        defaultvalue: "",
        primary: false,
        sequence: "",
        required: false,
        groupfieldsattributes: "",
      };
      this.droppedDataFieldList.push(blank_data);
      console.log("Dropped data:", this.droppedDataFieldList);
      console.log("Dropped :", event);
    }
  }

  sectiondialog() {
    const dialogRef = this.dialog.open(SectionDialogComponent, {
      data: { sectionName: this.sectionName },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The section dialog was closed");
      if (result) {
        this.sectionName = result; // Update the section name with the result from the dialog
      }
    });
  }

  showDialog2(): void {
    const dialogRef = this.dialog.open(DialogComponent);
    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed");
    });
  }

  buttons: Button[];
}
